
"use client";

import Link from "next/link";
import { useState } from "react";
import { useTheme } from "../context/ThemeContext";

export type Event = {
  id: number;
  Title: string;
  slug: string;
  typeEvent: string;
  date: string;
  photocover: { url: string | null; alternativeText: string };
};

type EventCardProps = {
  event: Event;
};

export default function EventCard({ event }: EventCardProps) {
  const [imageLoading, setImageLoading] = useState(true);
  const { theme } = useTheme();
  const eventDate = new Date(event.date);
  const isPastEvent = eventDate < new Date();

  const formattedDate = eventDate.toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

  const imageUrl = event.photocover?.url ? event.photocover.url : "/default.png";

  return (
    <Link href={`/Events/${event.slug}`} className="group block">
      <div className={`rounded-2xl border overflow-hidden transition-all duration-500 hover:scale-105 ${
        theme === "dark"
          ? "bg-gray-800/80 border-gray-700"
          : "bg-white/80 border-gray-200"
      }`}>
        <div className="relative overflow-hidden">
          {imageLoading && (
            <div className={`w-full h-48 animate-pulse ${
              theme === "dark" ? "bg-gray-700" : "bg-gray-200"
            }`} />
          )}
          <img
            src={imageUrl}
            alt={event.photocover?.alternativeText || event.Title}
            className={`w-full h-48 object-cover transition-all duration-700 ${
              imageLoading ? "opacity-0" : "opacity-100"
            }`}
            onLoad={() => setImageLoading(false)}
          />
          <div className="absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-semibold backdrop-blur-sm border bg-white/80 text-gray-700">
            {event.typeEvent}
          </div>
          <div className={`absolute top-4 right-4 px-3 py-1 rounded-full text-xs font-semibold backdrop-blur-sm border ${
            isPastEvent ? "bg-gray-100/80 text-gray-600" : "bg-green-100/80 text-green-700"
          }`}>
            {isPastEvent ? "Terminé" : "À venir"}
          </div>
        </div>
        <div className="p-6">
          <div className="text-sm font-medium mb-3 text-blue-600">{formattedDate}</div>
          <h3 className="text-xl font-bold mb-4 text-gray-900">{event.Title}</h3>
        </div>
      </div>
    </Link>
  );
}













 